import { render, staticRenderFns } from "./SearchProductResult.vue?vue&type=template&id=de71543e"
import script from "./SearchProductResult.vue?vue&type=script&lang=js"
export * from "./SearchProductResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports